import { defineMessages } from 'react-intl';

export const msgs = defineMessages({
  label: {
    id: 'pib_learnable_card_title',
  },
  meta: {
    id: 'pib_learnable_card_type',
  },
});
